import moment from 'moment'
import cookieService from 'vue-cookies'

export function createGUID() {
  // Create cart UUID
  function s4() {
    return Math.floor((1 + Math.random()) * 0x10000)
      .toString(16)
      .substring(1)
  }
  return `${s4() + s4()}-${s4()}-${s4()}-${s4()}-${s4()}${s4()}${s4()}`
}

// Quick notes
// So there is a cookie named 'socC1' (shop on campus cookie 1)
// In it we store an object (we'll call it 'storage')
// Storage has three properties: payload, id, and expiry
// Expiry is timestamp of that the cookie expires (7 days in the future)
// ID is the ID if the created shopping cart on the server
// payload is the GUID the client generates which is sent to the server to create the cart

export function getCartGUID() {
  const cookie = getCookie()
  if (cookie) return cookie.payload
  return null
}

export function getCartId() {
  const cookie = getCookie()
  if (cookie) return cookie.id
  return null
}

function getCookie() {
  const storage = cookieService.get('socC1')
  if (storage != null) {
    if (Object.prototype.hasOwnProperty.call(storage, 'expiry')) {
      const diff = moment(storage.expiry).diff(moment(), 'days')
      if (diff < 7) return storage
      cookieService.remove('socC1')
    }
  }
  return null
}

export function createNewCartId(id, cookie) {
  if (!cookie) {
    cookie = createGUID()
  }
  // Create cartId
  const bundle = {
    payload: cookie,
    id: id,
    expiry: moment().add('7', 'days'),
  }
  cookieService.set('socC1', JSON.stringify(bundle), '7d')
  return bundle.payload
}

// Called after purchase, clearing cart
export function resetCartId(id) {
  const bundle = {
    payload: createGUID(),
    id: id,
    expiry: moment().add('7', 'days'),
  }
  cookieService.set('socC1', JSON.stringify(bundle), '7d')
  return bundle.payload
}
